// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "action-3DhE9";
export { _1 as "__esModule", _2 as "action" }
export default { "__esModule": _1, "action": _2 }
